import { actionTypes } from '../actions/news'

const initial = {
	list: [],
	sectorList: [],
  order: ''
}

export default (state = initial, action) => {
  switch (action.type) {

  	case actionTypes.RECEIVE_NEWS:
      return Object.assign({}, state, {
        list: action.data
    })

    case actionTypes.RECEIVE_SECTOR_NEWS:
      if (action.data.length > 0){
        var sectorList = action.data
      }
      else{
        var sectorList = []
      }
      return Object.assign({}, state, { sectorList })

    case actionTypes.RECEIVE_ORDERED_NEWS:
      return Object.assign({}, state, {
        list: action.data
    })

    case actionTypes.SAVE_ORDER:
      return Object.assign({}, state, {
        order: action.data
    })

  	default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/news.js